import {atom} from 'recoil';
import {IUserAccount} from '../../shared/types/user-account.types';
import {IPageableDto, IPageableTable} from '../../shared/types/pageable.types';
import {getEmptyPage} from '../../shared/helpers/getEmptyPage';

export const userAccountsQueryTrigger = atom<number>({
  key: 'userAccountsQueryTrigger',
  default: 0,
});

export const userAccountsState = atom<IPageableDto<IUserAccount>>({
  key: 'userAccountsState',
  default: getEmptyPage<IUserAccount>(),
});

export const currentUserAccountState = atom<IUserAccount | null>({
  key: 'currentUserAccountState',
  default: null,
});

export const currentUserAccountIdState = atom<string | null>({
  key: 'currentUserAccountIdState',
  default: null,
});

export const userAccountControlModeState = atom<'ADD' | 'EDIT'>({
  key: 'userAccountControlModeState',
  default: 'ADD',
});

export const userAccountControlState = atom<boolean>({
  key: 'userAccountControlState',
  default: false,
});

export const userPageable = atom<IPageableTable>({
  key: 'userPageable',
  default: {
    page: 0,
    size: localStorage.getItem('usersPerPage') ? parseInt(localStorage.getItem('usersPerPage') as string, 10) : 5,
  },
});

export const userSortQueryTrigger = atom<{field: string; sort: 'asc' | 'desc' | null | undefined}[]>({
  key: 'userSortQueryTrigger',
  default: [],
});

export const userSearchSortQueryTrigger = atom<string>({
  key: 'userSearchSortQueryTrigger',
  default: '',
});
